export default {
    review: {
        title: 'Revisión de Documento',
        loading: 'Cargando documento...',
        share: {
            title: 'Compartir documento',
            tabs: {
                invite: 'Invitar personas',
                access: 'Personas con acceso',
                link: 'Obtener enlace',
            },
            inviteType: {
                receiver: 'Destinatarios Existentes',
                email: 'Email Personalizado',
                addressbook: 'Libreta de Direcciones',
            },
            fields: {
                recipients: 'Destinatarios',
                recipientsPlaceholder: 'Buscar destinatarios...',
                email: 'Email',
                emailPlaceholder: 'ingresa@email.com',
                contacts: 'Contactos de la Libreta de Direcciones',
                contactsPlaceholder: 'Buscar contactos...',
                message: 'Mensaje (opcional)',
                messagePlaceholder: 'Añade un mensaje opcional...',
            },
            actions: {
                send: 'Enviar',
                cancel: 'Cancelar',
            },
            noInvites: 'Aún no se han enviado invitaciones',
            revokeAccess: 'Revocar Acceso',
            resend: 'Reenviar',
            revoke: 'Revocar',
            generateLinkDescription: 'Genera un enlace de compartir que permite a cualquiera acceder al documento sin autenticación.',
            linkExpiration: 'Expiración del Enlace',
            expirationOptions: {
                never: 'Nunca',
                '1day': '1 día',
                '7days': '7 días',
                '30days': '30 días',
            },
            permissions: {
                view: 'Ver',
                edit: 'Editar',
            },
            generateLink: 'Generar Enlace',
            shareLink: 'Enlace de Compartir',
            copy: 'Copiar',
            copied: '¡Copiado!',
            linkWarning: 'Cualquiera con este enlace puede acceder al documento. Solo compártelo con personas de confianza.',
            generateNewLink: 'Generar Nuevo Enlace',
        },
        triage: {
            title: 'Triage de Documento',
            subtitle: 'Contenedor',
            goToContainerTriage: 'Ir al Triage de Documentos',
            resolveWithAI: 'Resolver con IA',
            tabs: {
                visual: 'Visual',
                raw: 'Datos Sin Procesar',
            },
            visual: {
                document: 'Documento',
                attributes: 'Atributos Extraídos',
                values: 'Valores',
            },
            raw: {
                json: 'JSON',
                highlightDiscrepancies: 'Resaltar discrepancias',
            },
            attributes: {
                invoiceNumber: 'Número de Factura',
                amount: 'Importe',
                currency: 'Moneda',
                issueDate: 'Fecha de Emisión',
                dueDate: 'Fecha de Vencimiento',
                shipper: 'Expedidor',
                consignee: 'Consignatario',
                containerNumber: 'Número de Contenedor',
                blNumber: 'Número BL',
            },
            modal: {
                title: 'Resolviendo discrepancias con IA',
                analyzing: 'Analizando y corrigiendo atributos extraídos…',
                completed: 'Resolución completada',
                allResolved: 'Todas las discrepancias se han resuelto. Puedes cerrar esta ventana para ver los resultados actualizados.',
                close: 'Cerrar',
            },
        },
        status: {
            pending: 'Pendiente',
            accepted: 'Aceptado',
            rejected: 'Rechazado',
        },
    },
    history: {
        title: 'Historial de Versiones del Documento',
        subtitle: 'Documento',
        container: 'Contenedor',
        loading: 'Cargando historial de versiones...',
        notFound: {
            title: 'Documento no encontrado',
            message: 'El documento solicitado no existe.',
            backToContainer: 'Volver al contenedor',
        },
        versions: {
            count: 'versión',
            versions: 'versiones',
        },
        info: {
            documentType: 'Tipo de Documento',
            currentVersion: 'Versión Actual',
            version: 'Versión',
        },
        empty: {
            title: 'Sin historial de versiones',
            message: 'Este documento no tiene historial de versiones registrado.',
        },
        description: {
            uploadedBy: 'Subido por',
        },
    },
    triage: {
        title: 'Triage de Documento',
        subtitle: 'Contenedor',
        loading: 'Cargando documento...',
        goToContainerTriage: 'Ir al Triage del Contenedor',
        resolveWithAI: 'Resolver con IA',
        tabs: {
            visual: 'Visual',
            raw: 'Datos Sin Procesar',
        },
        visual: {
            check: 'Verificar',
            ok: 'OK',
        },
        raw: {
            json: 'JSON',
            highlightDiscrepancies: 'Resaltar discrepancias',
        },
        attributes: {
            invoiceNumber: 'Número de Factura',
            amount: 'Importe',
            currency: 'Moneda',
            issueDate: 'Fecha de Emisión',
            dueDate: 'Fecha de Vencimiento',
            shipper: 'Expedidor',
            consignee: 'Consignatario',
            containerNumber: 'Número de Contenedor',
            blNumber: 'Número BL',
        },
        modal: {
            title: 'Resolviendo discrepancias con IA',
            analyzing: 'Analizando y corrigiendo atributos extraídos…',
            completed: 'Resolución completada',
            allResolved: 'Todas las discrepancias se han resuelto. Puedes cerrar esta ventana para ver los resultados actualizados.',
            close: 'Cerrar',
        },
    },
    drive: {
        title: 'Documentos',
        myDrive: 'Mi Unidad',
        unmappedFiles: 'Archivos No Asociados',
        showEmptyFolders: 'Mostrar carpetas vacías',
        search: {
            placeholder: 'Buscar documentos, carpetas, contenedores...',
            noResults: 'No se encontraron resultados',
            results: 'Resultados de Búsqueda',
        },
        breadcrumb: {
            home: 'Mi Unidad',
        },
        view: {
            card: 'Vista de Tarjetas',
            list: 'Vista de Lista',
        },
        folder: {
            container: 'Contenedor',
            customFolder: 'Carpeta Personalizada',
            documentsCount: '{{count}} documento',
            documentsCount_plural: '{{count}} documentos',
            create: 'Crear Carpeta',
            open: 'Abrir',
            rename: 'Renombrar',
            delete: 'Eliminar',
            moveAction: 'Mover',
            cannotDelete: 'Las carpetas de contenedor no se pueden eliminar',
            cannotRename: 'Las carpetas de contenedor no se pueden renombrar',
            move: {
                title: 'Mover Carpeta',
                label: 'Seleccionar Carpeta Destino',
                root: 'Raíz (Mi Unidad)',
                save: 'Mover',
                cancel: 'Cancelar',
            },
            createModal: {
                title: 'Crear Carpeta',
                label: 'Nombre de Carpeta',
                parentLabel: 'Carpeta Principal (opcional)',
                save: 'Crear',
                cancel: 'Cancelar',
            },
        },
        upload: {
            title: 'Subir Documentos',
            dropZone: 'Arrastra archivos aquí o haz clic para seleccionar',
            success: 'Documentos subidos exitosamente',
        },
        document: {
            actions: {
                download: 'Descargar',
                rename: 'Renombrar',
                move: 'Mover',
                share: 'Compartir',
                delete: 'Eliminar',
            },
            rename: {
                title: 'Renombrar Documento',
                label: 'Nombre',
                save: 'Guardar',
                cancel: 'Cancelar',
            },
            move: {
                title: 'Mover Documento',
                label: 'Seleccionar Contenedor',
                save: 'Mover',
                cancel: 'Cancelar',
            },
            share: {
                title: 'Compartir Documento',
                email: 'Email',
                permission: 'Permiso',
                view: 'Ver',
                edit: 'Editar',
                comment: 'Comentar',
                send: 'Enviar',
                cancel: 'Cancelar',
            },
            delete: {
                title: 'Eliminar Documento',
                message: '¿Estás seguro de que quieres eliminar este documento? Esta acción no se puede deshacer.',
                confirm: 'Eliminar',
                cancel: 'Cancelar',
            },
        },
        unmapped: {
            title: 'Archivos No Asociados',
            description: 'Archivos que aún no están asociados con un contenedor',
            empty: {
                title: 'No hay archivos no asociados',
                message: 'Todos los archivos están asociados con un contenedor.',
            },
            bulkActions: {
                selectAll: 'Seleccionar Todo',
                deselectAll: 'Deseleccionar Todo',
                selectAllLabel: 'Selecciona todos los archivos para asociarlos a un contenedor:',
                associate: 'Asociar a Contenedor',
                selected: '{{count}} seleccionado',
                selected_plural: '{{count}} seleccionados',
            },
            associate: {
                title: 'Asociar Archivos a Contenedor',
                label: 'Seleccionar Contenedor',
                save: 'Asociar',
                cancel: 'Cancelar',
            },
        },
        detail: {
            containerInfo: 'Información del Contenedor',
            versions: 'Versiones',
            currentVersion: 'Versión Actual',
            viewVersion: 'Ver Versión',
            download: 'Descargar',
            previewNotAvailable: 'Vista previa no disponible para este tipo de archivo',
            notFound: 'Documento no encontrado',
            backToDocuments: 'Volver a Documentos',
            downloadConfirm: {
                title: 'Descargar Archivo',
                message: 'Este archivo no se puede ver en el navegador. ¿Quieres descargarlo?',
                download: 'Descargar',
                cancel: 'Cancelar',
            },
        },
    },
};

